
/**
 * 圆形通视
 */

import DrawCircle from "../plot/DrawCircle"

import { getEllipseOuterPositions } from "./utils/index"
import { computeSurfaceLine, getSpace } from "./utils/index"
import { cartesian2lonlat } from "./utils/geojson"
import ConstantDraw from "../constants/ConstantDraw"
class IntervisibileCircle extends DrawCircle {

    constructor(options) {
        super(options);
        this.options = options;
    }
    initEditor() {

    }

    leftDoubleClick(evt) {
        super.leftDoubleClick();
        this.options.analysisStart();
        var $this = this;
        var positions = getEllipseOuterPositions({
            position: $this.positions[0],
            semiMajorAxis: $this.plot.ellipse.semiMajorAxis.getValue(),
            semiMinorAxis: $this.plot.ellipse.semiMinorAxis.getValue(),
            count: 18
        });

        function* generator() {

            for (let i = 0; i < positions.length; i++) {
                var start = $this.positions[0];
                var end = positions[i];
                yield new Promise((resolve, reject) => {
                    computeSurfaceLine({
                        scene: $this.viewer.scene,
                        positions: [start, end],
                        splitNum:18,
                        calback: (raisedPositions, noHeight, positions) => {
                            $this.viewer.entities.remove($this.plot);
                            $this.calculate(raisedPositions);
                            resolve();
                        }
                    });

                })

            }
        }

        function run(res) {
            if (!res.done) {
                res.value
                    .then(() => {
                        run(gen.next());
                    });
            }
            if(res.done){
                $this.options.analysisDone();
            }
        }

        let gen = generator();
        run(gen.next());

    }

    calculate(posArr) {
        var $this = this;
        var L = posArr.length;
        var start = posArr[0];
        var end = posArr[L - 1];
        var start_lonlat = cartesian2lonlat(start);
        var end_lonlat = cartesian2lonlat(end);
        var all_x = getSpace(posArr[0], Cesium.Cartesian3.fromDegrees(end_lonlat[0], end_lonlat[1], start_lonlat[2]));
        var all_y = Math.abs(end_lonlat[2] - start_lonlat[2]);
        var noAdd=true; //默认无盲点
        //从低向高看
        if (start_lonlat[2] <= end_lonlat[2]) {
            let growMax = start_lonlat[2];
            for (let i = 0; i < L - 1; i++) {
                var lonlat_step_x_start = cartesian2lonlat(posArr[i]); //下一点
                var lonlat_step_x_end = cartesian2lonlat(posArr[i + 1]); //下一点
                var step_pos_start = Cesium.Cartesian3.fromDegrees(lonlat_step_x_start[0], lonlat_step_x_start[1], start_lonlat[2]);
                var step_pos_end = Cesium.Cartesian3.fromDegrees(lonlat_step_x_end[0], lonlat_step_x_end[1], start_lonlat[2]);
                var step_x = getSpace(step_pos_start, step_pos_end);
                var grow = this.getGrowthY(step_x, all_x, all_y);
                growMax += grow;
                if (lonlat_step_x_end[2] > growMax) {
                    //盲点
                    //var label = ConstantDraw.Style_Label;
                    //label.text = "盲点";
                    //this.blind_pos = this.createPoint(posArr[i + 1]);
                    //this.blind_pos.label = label;

                    var Style_LineGreen = ConstantDraw.Style_LineNor;
                    Style_LineGreen.material = Cesium.Color.GREEN;
                    Style_LineGreen.clampToGround = false;
                    $this.plot_start = this.createPolyline([start, posArr[i + 1]], Style_LineGreen);


                    var Style_LineRed = ConstantDraw.Style_LineNor;
                    Style_LineRed.clampToGround = false;
                    Style_LineRed.material = Cesium.Color.RED;
                    $this.plot_end = this.createPolyline([posArr[i + 1], end], Style_LineRed);
                    $this.entities.push($this.plot_start);
                    $this.entities.push($this.plot_end);
                    noAdd=false;
                    break;
                }

            }
        }
        //从高向低看
        else {
            //倒着来
            let growMax = end_lonlat[2];
            for (let i = L - 1; i >= 1; i--) {
                var lonlat_step_x_start = cartesian2lonlat(posArr[i - 1]); //前一点
                var lonlat_step_x_end = cartesian2lonlat(posArr[i]); //
                var step_pos_start = Cesium.Cartesian3.fromDegrees(lonlat_step_x_start[0], lonlat_step_x_start[1], end_lonlat[2]);
                var step_pos_end = Cesium.Cartesian3.fromDegrees(lonlat_step_x_end[0], lonlat_step_x_end[1], end_lonlat[2]);
                var step_x = getSpace(step_pos_start, step_pos_end);
                var grow = this.getGrowthY(step_x, all_x, all_y);
                growMax += grow;
                if (lonlat_step_x_start[2] > growMax) {
                    //盲点
                    //var label = ConstantDraw.Style_Label;
                    //label.text = "盲点";
                    //this.blind_pos = this.createPoint(posArr[i - 1]);
                    //this.blind_pos.label = label;

                    var Style_LineGreen = ConstantDraw.Style_LineNor;
                    Style_LineGreen.material = Cesium.Color.GREEN;
                    Style_LineGreen.clampToGround = false;
                    $this.plot_start = this.createPolyline([start, posArr[i - 1]], Style_LineGreen);

                    var Style_LineRed = ConstantDraw.Style_LineNor;
                    Style_LineRed.clampToGround = false;
                    Style_LineRed.material = Cesium.Color.RED;
                    $this.plot_end = this.createPolyline([posArr[i - 1], end], Style_LineRed);
                    $this.entities.push($this.plot_start);
                    $this.entities.push($this.plot_end);
                    noAdd=false;
                    break;
                }

            }
        }

        //无盲点
        if(noAdd){
            var Style_LineGreen = ConstantDraw.Style_LineNor;
            Style_LineGreen.material = Cesium.Color.GREEN;
            Style_LineGreen.clampToGround = false;
            var plot_temp = this.createPolyline([start, end], Style_LineGreen);
            $this.entities.push(plot_temp);
        }

    }

    //获取高度增长量
    getGrowthY(step_x, all_x, all_y) {
        return (step_x / all_x) * all_y
    }



}

export default IntervisibileCircle;